module.exports = __webpack_public_path__ + "img/coins.92321c8c.png";